import Client from './Clients/AxiosClient'
const resource = '/testIndication'

export default {
  get(params = {}) {
    return Client.get(resource, { params })
  },
  getDeleted(params = {}) {
    return Client.get(resource, { params: { status: false, ...params } })
  },
  getTest(id) {
    return Client.get(`${resource}/${id}`)
  },
  create(payload) {
    return Client.post(`${resource}`, payload)
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return Client.put(`${resource}/status/${id}`, { status: false })
  },
  reactivate(id) {
    return Client.put(`${resource}/status/${id}`, { status: true })
  },
}
